import { AnomalyModel } from 'projects/phdsoft/common/src/lib/models/anomaly.model';
import { AssetInfoModel, Util } from "@phdsoft/common";
import { Collection } from "../Campaigns/Collection";
import { InspectionCampaign } from "../Campaigns/InspectionCampaign";
import { RepairCampaign } from "../Campaigns/RepairCampaign";
import { DocumentsCollection } from "../Campaigns/document-collection";
import { StructureCollection } from "../Campaigns/StructureCollection";
import { DomainEntity } from "../DomainEntity";
import { Material } from "../ResourceElements/Material";
import { MaterialType } from "../ResourceElements/MaterialType";
import { ThicknessColorTable } from "../ResourceElements/thickness-color-table";
import { AssetState, AssetStateList } from "./asset-state";
import * as THREE from '@phdsoft/three';
import { Modes } from "./mode";
import { Region } from "./Region";
import { Graphics } from "src/app/digital-twin/graphics/graphics";
import { WorkableElement } from "../SectionElements/WorkableElement";
import { VisualizationMode } from "src/app/template/menu/menu.service";
import { SensorCollection } from "../Campaigns/SensorCollection";
import { ProtectionElementsCampaign } from '../Campaigns/ProtectionElementsCampaign';
import { CriticalAreaCampaign } from '../Campaigns/CriticalAreaCampaign';
import { AnomalyRepairModel } from 'projects/phdsoft/common/src/lib/models/anomaly-repair.model';
import { AnomalyActionModel } from 'projects/phdsoft/common/src/lib/models/anomaly-action.model';
import { SurfaceElement } from '../SectionElements/StructureElements/SurfaceElement';
import { GraphicsMaterials } from 'src/app/digital-twin/graphics/graphics-materials';
import { LightSectionModRenderer } from 'src/app/digital-twin/Loader/LightSectionModRenderer';
import { WeightTemporalElementsCampaign } from '../Campaigns/WeightTemporalElementsCampaign';
import { TemporalCollection } from '../Campaigns/TemporalCollection';
import { NonWorkableElement } from '../SectionElements/NonWorkableElement';
import { StructuralConnectionCollection } from '../Campaigns/StructuralConnectionCollection';
import { SectionBorderSettings } from './section-border-settings';
// was: import { repairBordersVisible, setRepairBorderLinesVisible } from './repair-border-visibility';
import {
    elementOverlayBordersVisible,
    repairBordersVisible,
    setElementOverlayBorderLinesVisible,
    setRepairBorderLinesVisible,
} from './repair-border-visibility';
import type { LightModelEdges } from 'src/app/digital-twin/Loader/light-model-edges';

export class Asset extends DomainEntity {

    private _viewMode: VisualizationMode;
    public get viewMode(): VisualizationMode {
        return this._viewMode;
    }
    public set viewMode(v: VisualizationMode) {
        this._viewMode = v;
    }

    private _visualizationMode: VisualizationMode;
    public get visualizationMode(): VisualizationMode {
        return this._visualizationMode;
    }
    public set visualizationMode(v: VisualizationMode) {
        this._visualizationMode = v;
    }

    private _elementsProperties: Array<any>;
    public get elementsProperties(): Array<any> {
        return this._elementsProperties;
    }
    public set elementsProperties(v: Array<any>) {
        this._elementsProperties = v;
    }

    public graphics: Graphics;
    private _assetInfo: AssetInfoModel;
    public set assetInfo(v: AssetInfoModel) {
        this._assetInfo = v;
    }
    public get assetInfo(): AssetInfoModel {
        return this._assetInfo;
    }
    private _Campaigns: Array<Collection>;
    public get Campaigns(): Array<Collection> {
        return this._Campaigns;
    }
    public set Campaigns(v: Array<Collection>) {
        this._Campaigns = v;
    }

    private _TemporalCampaigns : Array<TemporalCollection>;
    public get TemporalCampaigns() : Array<TemporalCollection> {
        return this._TemporalCampaigns;
    }
    public set TemporalCampaigns(v : Array<TemporalCollection>) {
        this._TemporalCampaigns = v;
    }

    private _lightCampaign : StructureCollection;
    public get lightCampaign() : StructureCollection {
        return this._lightCampaign;
    }
    public set lightCampaign(v : StructureCollection) {
        this._lightCampaign = v;
    }


    private _anomalies: AnomalyModel[];
    public set anomalies(v: AnomalyModel[]) {
        this._anomalies = v;
    }
    public get anomalies(): AnomalyModel[] {
        return this._anomalies;
    }
    private _box3: THREE.Box3;
    public get box3(): THREE.Box3 {
        return this._box3;
    }
    public set box3(v: THREE.Box3) {
        this._box3 = v;
    }

    public repairsList: AnomalyRepairModel[] = []
    public mitigationsList: AnomalyActionModel[] = []


    private _pipeInformation = {
        0: false,
        45: false,
        90: false,
        135: false,
        180: false,
        225: false,
        270: false,
        315: false,
    };

    private missingRegions;

    public get pipeInformation() {
        return this._pipeInformation;
    }
    public set pipeInformation(v) {
        this._pipeInformation = v;
    }
    public assetStateList: AssetStateList = new AssetStateList();

    public documentsVisibility: boolean = false;
    public isLightModel: boolean = false;
    public isNewModelMode: boolean = false;

    public group: THREE.Group;
    public cssGroup: THREE.Group;


    private _changeSectionVisibility: boolean = false;
    public get changeSectionVisibility(): boolean {
        return this._changeSectionVisibility;
    }
    public set changeSectionVisibility(v: boolean) {
        this._changeSectionVisibility = v;
    }


    public lightSectionModRenderer: LightSectionModRenderer | null = null;

    /** Crease edges drawn on the light model (AssetLoader.loadLightModel); null without a light model. */
    public lightModelEdges: LightModelEdges | null = null;

    /** Persisted "show section borders" setting (default true); see SectionBorderSettings. */
    public get showSectionBorders(): boolean {
        return SectionBorderSettings.show;
    }
    public set showSectionBorders(v: boolean) {
        SectionBorderSettings.show = v;
    }

    /** The setting covers new-format assets in REGIONS, and in MODEL without a light model. SECTIONS always shows borders. */
    public get sectionBordersSettingApplies(): boolean {
        return this.isNewModelMode && (this._mode === 'REGIONS' || (this._mode === 'MODEL' && !this.isLightModel));
    }

    /** The setting also covers the light model's crease edges, shown in MODEL navigation. */
    public get lightModelEdgesSettingApplies(): boolean {
        return this.isLightModel && this._mode === 'MODEL';
    }

    /**
     * Re-applies the setting to every structure region's Borders group (borderGroup.visible only;
     * hidden regions/sections stay hidden through their own groups). No-op outside the covered modes.
     * The light-model edges always follow the setting (they inherit their mesh's visibility).
     * Repair element borders are re-applied in every mode (applyRepairBorderVisibility; SECTIONS restores them).
     * Critical-area borders too (applyElementOverlayBorderVisibility covers repairs and critical areas).
     * @returns true when the structure Borders were updated.
     */
    public applySectionBorderVisibility(): boolean {
        this.lightModelEdges?.setVisible(SectionBorderSettings.show);
        // Repair borders live on their SurfaceDesign, not in section.borderGroup: before the early return so SECTIONS restores them
        // was: this.applyRepairBorderVisibility();
        // Critical-area borders live on their SurfaceDesign as well: same rule, same place
        this.applyElementOverlayBorderVisibility();
        if (!this.sectionBordersSettingApplies) return false;
        this.GetAllStructureRegions().forEach(region => region.applySectionBorderSetting());
        return true;
    }

    /**
     * Applies the "show section borders" setting to the borders of every repair element of every
     * RepairCampaign (LineLoop/LineSegments children of its SurfaceDesign, see GeometricElement.createBorder),
     * per repairBordersVisible. Touches those line children only: SurfaceDesign.visible belongs to the
     * timeline filter (loadRegionRepairsWithVisibilityControl), light-model edges are skipped.
     * @returns the number of border lines whose visibility changed.
     */
    public applyRepairBorderVisibility(): number {
        const visible = repairBordersVisible({
            isNewModelMode: this.isNewModelMode,
            mode: this._mode,
            show: SectionBorderSettings.show,
        });
        let changed = 0;
        this.RepairCampaigns?.forEach(repairCampaign => {
            repairCampaign?.Elements?.forEach(element => {
                changed += setRepairBorderLinesVisible(element?.SurfaceDesign, visible);
            });
        });
        return changed;
    }

    /**
     * Applies the "show section borders" setting to the borders of every critical-area element of every
     * CriticalAreaCampaign (LineLoop/LineSegments children of its SurfaceDesign, see GeometricElement.createBorder),
     * per elementOverlayBordersVisible (same rule as the repairs). Touches those line children only:
     * SurfaceDesign.visible belongs to the critical-area filters / Risk view mode, light-model edges are skipped.
     * @returns the number of border lines whose visibility changed.
     */
    public applyCriticalAreaBorderVisibility(): number {
        const visible = elementOverlayBordersVisible({
            isNewModelMode: this.isNewModelMode,
            mode: this._mode,
            show: SectionBorderSettings.show,
        });
        let changed = 0;
        this.CriticalAreaCampaigns?.forEach(criticalAreaCampaign => {
            criticalAreaCampaign?.Elements?.forEach(element => {
                changed += setElementOverlayBorderLinesVisible(element?.SurfaceDesign, visible);
            });
        });
        return changed;
    }

    /**
     * Element overlay borders (own createBorder lines, outside section.borderGroup): repairs and critical areas.
     * @returns the number of border lines whose visibility changed.
     */
    public applyElementOverlayBorderVisibility(): number {
        return this.applyRepairBorderVisibility() + this.applyCriticalAreaBorderVisibility();
    }

    private _mode: Modes;
    public get mode(): Modes {
        return this._mode;
    }
    public set mode(v: Modes) {
        this._mode = v;

        switch (this._mode) {
            case 'MODEL':
                this.currentRegionsIds = [];
                for (const structureCampaign of this.StructureCampaigns) {
                    for (const region of structureCampaign.regionsWorkableElements) {
                        region.clearBorderofElements();
                        region.renderLinearElements(false);
                        // New format without light model: clearBorderofElements hid the GLTF Borders; MODEL follows the "show section borders" setting
                        if (this.isNewModelMode && !this.isLightModel) region.applySectionBorderSetting();
                    }
                }
                this.graphics.Controls.enableRotate = true;
                this.lightSectionModRenderer?.detach();
                break;
            case 'REGIONS':
                this.clearModelTemporalElement();
                if (this.lightSectionModRenderer && this._assetInfo?.AssetId) {
                    void this.lightSectionModRenderer.attach(this._assetInfo.AssetId, this.group);
                }
                break;
            case 'SECTIONS':
                this.clearModelTemporalElement();
                this.lightSectionModRenderer?.detach();
                break;
            default:
                break;
        }
        // Repair element borders follow the "show section borders" setting in MODEL/REGIONS, shown in SECTIONS
        // was: this.applyRepairBorderVisibility();
        // Critical-area borders follow the same rule
        this.applyElementOverlayBorderVisibility();
    }

    public currentRegionsIds: string[];


    private _materials: Array<MaterialType>;
    public get materials(): Array<MaterialType> {
        return this._materials;
    }


    private _currentSelectedElement: WorkableElement;
    public get currentSelectedElement(): WorkableElement {
        return this._currentSelectedElement;
    }
    public set currentSelectedElement(v: WorkableElement) {
        this._currentSelectedElement = v;
    }


    private _thicknessColorTable: Array<ThicknessColorTable>;
    public get thicknessColorTable(): Array<ThicknessColorTable> {
        return this._thicknessColorTable;
    }
    public set thicknessColorTable(v: Array<ThicknessColorTable>) {
        this._thicknessColorTable = v;
    }

    constructor(graphics: Graphics) {
        super();
        this.group = new THREE.Group();
        this.cssGroup = new THREE.Group();
        this._mode = "MODEL";
        this.currentRegionsIds = []
        this.graphics = graphics;
    }


    public setMaterials(materialsList: any[]): void {
        this._materials = new Array<MaterialType>();
        for (const material of materialsList) {
            this._materials.push(new MaterialType(material));
        }
    }
    public setThicknessColorTable(thicknessColorTable: any[]): void {
        this._thicknessColorTable = new Array<ThicknessColorTable>();
        for (const thickness of thicknessColorTable) {
            this._thicknessColorTable.push(new ThicknessColorTable(thickness));
        }
    }

    public get StructureCampaigns(): Array<StructureCollection> {
        return this._Campaigns?.filter(x => x.Type === 'StructureCampaign') as Array<StructureCollection>;
    }

    public get InspectionCampaigns(): Array<InspectionCampaign> {
        return this._Campaigns?.filter(x => x.Type === 'InspectionCampaign') as Array<InspectionCampaign>;
    }

    public get RepairCampaigns(): Array<RepairCampaign> {
        return this._Campaigns?.filter(x => x.Type === 'RepairCampaign') as Array<RepairCampaign>;
    }

    public get CriticalAreaCampaigns(): Array<CriticalAreaCampaign> {
        return this._Campaigns?.filter(x => x.Type === 'CriticalAreaCampaign') as Array<CriticalAreaCampaign>;
    }

    public get SensorCampaign(): SensorCollection {
        return this._Campaigns?.find(x => x.Type === 'SensorCampaign') as SensorCollection;
    }

    private _StructuralConnectionCampaign: StructuralConnectionCollection;
    public get StructuralConnectionCampaign(): StructuralConnectionCollection {
        return this._Campaigns?.find(x => x.Type === 'StructuralConnectionCampaign') as StructuralConnectionCollection;
    }
    public set StructuralConnectionCampaign(v: StructuralConnectionCollection) {
        this._StructuralConnectionCampaign = v;
    }

    public get DocumentCollection(): DocumentsCollection {
        return this._Campaigns?.find(x => x.Type === 'DocumentCampaign') as DocumentsCollection;
    }

    public get ProtectionElementsCollection(): ProtectionElementsCampaign {
        if (!this._Campaigns) {
            return null;
        }
        return this._Campaigns.find(x => x.Type === 'ProtectionElementsCampaign') as ProtectionElementsCampaign;
    }

    public get WeightTemporalElementsCampaign(): WeightTemporalElementsCampaign {
        if (!this._TemporalCampaigns) {
            return null;
        }
        return this._TemporalCampaigns.find(x => x.Type === 'WeightTemporalElementsCampaign') as WeightTemporalElementsCampaign;
    }

    public GetAllStructureRegions(): Array<Region> {
        const regions = new Array<Region>();
        this.StructureCampaigns?.forEach(structureCampaign => {
            regions.push(...structureCampaign.regionsWorkableElements);
        });
        return regions;
    }

    public GetAllStructureRegionsAndLightmodel(): Array<Region> {
        const regions = new Array<Region>();
        this.StructureCampaigns?.forEach(structureCampaign => {
            regions.push(...structureCampaign.regionsWorkableElements);
        });
        regions.push(...this.lightCampaign?.regionsWorkableElements);
        return regions;
    }

    public GetLightModelRegions(): Array<Region> {
        const regions = new Array<Region>();
        regions.push(...this.lightCampaign?.regionsWorkableElements);
        return regions;
    }

    public GetLightModelMissingRegions(missingRegions?) {
        if (!this.missingRegions) this.missingRegions = missingRegions;
        if (this.missingRegions) {
            const regions = new Array<Region>();
            regions.push(...this.lightCampaign?.regionsWorkableElements.filter(rwe => this.missingRegions.some(mr => mr.id === rwe.Guid)));
            for (const region of regions) {
                for (const elem of region.surfaceElements) {
                    if (elem instanceof SurfaceElement) {
                        elem.SurfaceDesign.material = GraphicsMaterials.lightModelMaterial;
                        elem.currentMaterial = GraphicsMaterials.lightModelMaterial;
                    }
                }
            }
        }
    }

    public GetAllStructureGroups(): Array<THREE.Group> {
        const groups = new Array<THREE.Group>();
        this.StructureCampaigns.forEach(structureCampaign => {
            groups.push(structureCampaign.group);
        });
        return groups;
    }

    public GetVisibleLightModel(): Array<THREE.Group> {
        const visibleGroups = new Array<THREE.Group>();
        visibleGroups.push(...this.lightCampaign.VisibleRegionsGroups);
        if (this.WeightTemporalElementsCampaign) {
            visibleGroups.push(this.WeightTemporalElementsCampaign.group)
        }
        return visibleGroups;
    }

    /**
     * Keeps the light model (lightCampaign.group, ~16k Object3Ds) in the scene only while one of
     * its regions is visible. Hidden, it still sat under asset.group and three.js walked it every
     * frame (updateMatrixWorld, the CSS2D label pass). Nothing reads lightCampaign.group.parent:
     * consumers go through Region/Section objects and `.visible` flags. Detached meshes keep their
     * last matrixWorld, and asset.group never moves, so re-attaching needs no matrix refresh.
     * @returns true when it attached or detached the group, false when nothing changed.
     */
    public syncLightModelAttachment(): boolean {
        const lightCampaign = this.lightCampaign;
        if (!lightCampaign) return false;
        const lightGroup = lightCampaign.group;
        if (lightCampaign.regionsWorkableElements.some(r => r.visible)) {
            if (lightGroup.parent === this.group) return false;
            this.group.add(lightGroup);
            return true;
        }
        if (!lightGroup.parent) return false;
        lightGroup.removeFromParent();
        return true;
    }

    public GetVisibleGroups(): Array<THREE.Group> {
        const visibleGroups = new Array<THREE.Group>();
        if (this.mode != 'SECTIONS') {
            if (this.isNewModelMode) {
                visibleGroups.push(...this.GetVisibleLightSectionsGroups());
            } else {
                this.StructureCampaigns?.forEach(structureCampaign => {
                    visibleGroups.push(...structureCampaign.VisibleRegionsGroups);
                });
            }
            this.RepairCampaigns?.forEach(repairCampaign => {
                visibleGroups.push(...repairCampaign.VisibleRegionsGroups);
            });
            if (this.lightCampaign) {
                visibleGroups.push(...this.lightCampaign.VisibleRegionsGroups);
            }
        }
        else {
            this.StructureCampaigns.forEach(structureCampaign => {
                visibleGroups.push(...structureCampaign.VisibleRegionsGroups);
            });
            this.InspectionCampaigns.forEach(inspectionCampaign => {
                visibleGroups.push(...inspectionCampaign.VisibleRegionsGroups);
            });
            this.RepairCampaigns.forEach(repairCampaign => {
                visibleGroups.push(...repairCampaign.VisibleRegionsGroups);
            });
            this.CriticalAreaCampaigns.forEach(criticalAreaCampaings => {
                visibleGroups.push(...criticalAreaCampaings.VisibleRegionsGroups);
            });
            visibleGroups.push(...this.SensorCampaign.VisibleRegionsGroups);
            if (this.ProtectionElementsCollection) {
                visibleGroups.push(...this.ProtectionElementsCollection.VisibleRegionsGroups)
            }
        }

        if (this.StructuralConnectionCampaign && this.StructuralConnectionCampaign.group.visible) {
          visibleGroups.push(this.StructuralConnectionCampaign.group);
        }

        return visibleGroups;
    }

    /** Get light section groups from visible structure regions (for new model mode) */
    public GetVisibleLightSectionsGroups(): Array<THREE.Group> {
        const groups = new Array<THREE.Group>();
        this.StructureCampaigns?.forEach(structureCampaign => {
            for (const region of structureCampaign.VisibleRegions) {
                groups.push(...region.LightSectionsGroups);
            }
        });
        return groups;
    }

    public getSectionInspectionPoints(): Array<WorkableElement> {
        const visibleGroups = new Array<WorkableElement>();
        if (this.mode != 'SECTIONS') {
            return visibleGroups;
        }
        else {
            this.InspectionCampaigns.forEach(inspectionCampaign => {
                if (inspectionCampaign.group.visible) {
                    visibleGroups.push(...inspectionCampaign.Elements.filter(x => x.realVisibility));
                }
            });
        }
        return visibleGroups;
    }

    public GetStructureVisibleGroups(): Array<THREE.Group> {
        const visibleGroups = new Array<THREE.Group>();
        this.StructureCampaigns.forEach(structureCampaign => {
            visibleGroups.push(...structureCampaign.VisibleRegionsGroups);
        });
        return visibleGroups;
    }

    public GetLightModelVisibleGroups(): Array<THREE.Group> {
        const visibleGroups = new Array<THREE.Group>();
        visibleGroups.push(...this.lightCampaign.VisibleRegionsGroups);
        return visibleGroups;
    }

    public GetProtectionElementsVisibleGroups(): Array<THREE.Group> {
        const visibleGroups = new Array<THREE.Group>();
        visibleGroups.push(...this.ProtectionElementsCollection.VisibleRegionsGroups);
        return visibleGroups;
    }

    public GetVisibleRegions(): Array<Region> {
        const visibleGroups = new Array<Region>();
        if (this.mode !== 'SECTIONS') {
            this.StructureCampaigns?.forEach(structureCampaign => {
                visibleGroups.push(...structureCampaign.VisibleRegions);
            });
            this.RepairCampaigns?.forEach(structureCampaign => {
                visibleGroups.push(...structureCampaign.VisibleRegions);
            });
        }
        else {
            this.StructureCampaigns.forEach(structureCampaign => {
                visibleGroups.push(...structureCampaign.VisibleRegions);
            });
            this.InspectionCampaigns.forEach(inspectionCampaign => {
                if (inspectionCampaign.group.visible) {
                    visibleGroups.push(...inspectionCampaign.VisibleRegions);
                }
            });
            this.RepairCampaigns.forEach(repairCampaign => {
                visibleGroups.push(...repairCampaign.VisibleRegions);
            });
            this.CriticalAreaCampaigns.forEach(criticalAreaCampaings => {
                visibleGroups.push(...criticalAreaCampaings.VisibleRegions);
            });
            if(this.SensorCampaign.VisibleRegions){
                visibleGroups.push(...this.SensorCampaign.VisibleRegions);
            }
            if (this.ProtectionElementsCollection) {
                visibleGroups.push(...this.ProtectionElementsCollection.VisibleRegions)
            }
        }
        return visibleGroups;
    }

    public GetVisibleRegionsAllTypes(): Array<Region> {
        const visibleGroups = new Array<Region>();

        this.StructureCampaigns?.forEach(structureCampaign => {
            visibleGroups.push(...structureCampaign?.VisibleRegions);
        });
        this.InspectionCampaigns?.forEach(inspectionCampaign => {
            if (inspectionCampaign.group.visible) {
                visibleGroups.push(...inspectionCampaign?.VisibleRegions);
            }
        });
        this.RepairCampaigns?.forEach(repairCampaign => {
            visibleGroups.push(...repairCampaign?.VisibleRegions);
        });
        this.CriticalAreaCampaigns?.forEach(criticalAreaCampaings => {
            visibleGroups.push(...criticalAreaCampaings?.VisibleRegions);
        });

        if (this.SensorCampaign?.VisibleRegions) {
            visibleGroups.push(...this.SensorCampaign?.VisibleRegions);
        }
        if (this.ProtectionElementsCollection?.VisibleRegions) {
            visibleGroups.push(...this.ProtectionElementsCollection.VisibleRegions)
        }

        return visibleGroups;
    }

    public GetRegionsAllTypes(): Array<Region> {
        const visibleGroups = new Array<Region>();

        this.StructureCampaigns?.forEach(structureCampaign => {
            if (structureCampaign.regionsWorkableElements) {
                visibleGroups.push(...structureCampaign.regionsWorkableElements);
            }
        });

        this.InspectionCampaigns?.forEach(inspectionCampaign => {
            if (inspectionCampaign.regionsWorkableElements) {
                visibleGroups.push(...inspectionCampaign.regionsWorkableElements);
            }
        });

        this.RepairCampaigns?.forEach(repairCampaign => {
            if (repairCampaign.regionsWorkableElements) {
                visibleGroups.push(...repairCampaign.regionsWorkableElements);
            }
        });

        this.CriticalAreaCampaigns?.forEach(criticalAreaCampaings => {
            if (criticalAreaCampaings.regionsWorkableElements) {
                visibleGroups.push(...criticalAreaCampaings.regionsWorkableElements);
            }
        });

        if (this.SensorCampaign?.regionsWorkableElements) {
            visibleGroups.push(...this.SensorCampaign.regionsWorkableElements);
        }

        // if (this.lightCampaign) {
        //     visibleGroups.push(...this.lightCampaign.regionsWorkableElements);
        // }

        return visibleGroups;
    }


    public GetStructureRegion(regionId: string): Array<Region> {
        const visibleGroups = new Array<Region>();
        this.StructureCampaigns.forEach(structureCampaign => {
            visibleGroups.push(structureCampaign.RegionById(regionId));
        });
        this.RepairCampaigns.forEach(structureCampaign => {
            visibleGroups.push(structureCampaign.RegionById(regionId));
        });
        if (this.lightCampaign) visibleGroups.push(this.lightCampaign.RegionById(regionId));
        return visibleGroups;
    }

    public GetStructureRegions(): Array<Region> {
        const visibleGroups = new Array<Region>();
        this.StructureCampaigns.forEach(structureCampaign => {
            visibleGroups.push(...structureCampaign.regionsWorkableElements);
        });
        return visibleGroups;
    }

    public GetStructureAndRepairsRegions(): Array<Region> {
        const visibleGroups = new Array<Region>();
        this.StructureCampaigns.forEach(structureCampaign => {
            visibleGroups.push(...structureCampaign.regionsWorkableElements);
        });
        this.RepairCampaigns.forEach(structureCampaign => {
            visibleGroups.push(...structureCampaign.regionsWorkableElements);
        });
        if (this.lightCampaign) {
            visibleGroups.push(...this.GetLightModelRegions());
        }
        return visibleGroups;
    }

    public GetStructureVisibleRegions(): Array<Region> {
        const visibleGroups = new Array<Region>();

        if (this.StructureCampaigns) {
            this.StructureCampaigns.forEach(structureCampaign => {
                visibleGroups.push(...structureCampaign.VisibleRegions);
            });
        }

        return visibleGroups;
    }

    public GetStructureVisibleRegionsAndLightModel(): Array<Region> {
        const visibleGroups = new Array<Region>();

        if (this.StructureCampaigns) {
        this.StructureCampaigns.forEach(structureCampaign => {
        visibleGroups.push(...structureCampaign.VisibleRegions);
        });
        }

        if (this.lightCampaign) {
        visibleGroups.push(...this.GetLightModelRegions());
        }

        return visibleGroups;
    }

    public GetStructureAndRepairsVisibleRegions(): Array<Region> {
        const visibleGroups = new Array<Region>();
        this.StructureCampaigns.forEach(structureCampaign => {
            visibleGroups.push(...structureCampaign.VisibleRegions);
        });

        this.RepairCampaigns.forEach(structureCampaign => {
            visibleGroups.push(...structureCampaign.VisibleRegions);
        });

        return visibleGroups;
    }

    public GetProtectionElementsVisibleRegions(): Array<Region> {
        const visibleGroups = new Array<Region>();
        if(this.ProtectionElementsCollection)
            visibleGroups.push(...this.ProtectionElementsCollection?.VisibleRegions);
        return visibleGroups;
    }

    public GetInspectionVisibleRegions(): Array<Region> {
        const visibleGroups = new Array<Region>();
        this.InspectionCampaigns.forEach(inspectionCampaign => {
            visibleGroups.push(...inspectionCampaign.VisibleRegions);
        });
        return visibleGroups;
    }

    public getStructureElements(visible: boolean): Array<WorkableElement> {
        return visible ? this.GetStructureVisibleRegions().flatMap(x =>
            x.sections.flatMap(y => [...y.surfaceElements, ...y.linearElements]))
            .filter(x => x.realVisibility) : this.GetStructureVisibleRegions().flatMap(x =>
                x.sections.flatMap(y => [...y.surfaceElements, ...y.linearElements]));
    }

    public getStructureAndRepairsElements(visible: boolean): Array<WorkableElement> {
        return visible ? this.GetStructureAndRepairsVisibleRegions().flatMap(x =>
            x.sections.flatMap(y => [...y.surfaceElements, ...y.linearElements]))
            .filter(x => x.realVisibility) : this.GetStructureAndRepairsVisibleRegions().flatMap(x =>
                x.sections.flatMap(y => [...y.surfaceElements, ...y.linearElements]));
    }

    public getInspectionElements(visible: boolean): Array<WorkableElement> {
        return visible ? this.GetInspectionVisibleRegions().flatMap(x =>
            x.sections.flatMap(y => [...y.surfaceElements, ...y.linearElements]))
            .filter(x => x.realVisibility) : this.GetInspectionVisibleRegions().flatMap(x =>
                x.sections.flatMap(y => [...y.surfaceElements, ...y.linearElements]));
    }

    public getVisibleBox(): THREE.Box3 {
        const box = new THREE.Box3();
        var groups;
        if (this.isLightModel && this.mode == "MODEL") {
            groups = this.GetLightModelVisibleGroups();
        } else {
            groups = this.GetStructureVisibleGroups();
        }
        for (const group of groups) {
            for (const child of group.children) {
                if (child.visible) box.expandByObject(child);
            }
        }
        return box;
    }

    public setSectionsVisibility(regions: { [id: string]: { visible?: boolean, sections?: { [id: string]: boolean } } }, sections: { [id: string]: boolean }): void {
        this.StructureCampaigns.forEach(structureCampaign => {
            structureCampaign.setRegionsVisibility(regions);
        });
    }

    public setRegionsVisibility(regions: { [id: string]: { visible?: boolean, sections?: { [id: string]: boolean } } }): void {
        this.StructureCampaigns.forEach(structureCampaign => {
            structureCampaign.setRegionsVisibility(regions);
        });
        if (this.lightCampaign && this.mode == "MODEL") {
            this.lightCampaign.setRegionsVisibility(regions);
        }
        if (this.mode !== 'MODEL') {
            this.InspectionCampaigns.forEach(inspectionCampaign => {
                inspectionCampaign.setRegionsVisibility(regions);
            });
            this.RepairCampaigns.forEach(repairCampaign => {
                repairCampaign.setRegionsVisibility(regions);
            });
            this.CriticalAreaCampaigns.forEach(criticalAreaCampaign => {
                criticalAreaCampaign.setRegionsVisibility(regions);
            });
            this.SensorCampaign.setRegionsVisibility(regions);
        }
    }

    public setVisibilityForAll(v: boolean): void {
        this.mode = 'MODEL';
        const assetStateRoot = new AssetState();
        assetStateRoot.isRoot = true;
        // this.assetStateList.addAssetState(assetStateRoot);
        this.StructureCampaigns?.forEach(structureCampaign => {
            structureCampaign.setVisibilityForAll(v);
        });
        // Collection.setVisibilityForAll → Section.clearBorders hid the GLTF Borders; MODEL (new format, no light model) follows the setting
        if (this.isNewModelMode && !this.isLightModel) {
            this.GetAllStructureRegions().forEach(region => region.applySectionBorderSetting());
        }
        // The light model replaces the structure in MODEL: Collection.setVisibilityForAll(true) just showed every
        // loaded structure region, which would draw it inside the light model. Same rule as
        // SceneGraphRenderer.renderNewFormat / renderOldFormat (light-model MODEL hides the structure regions).
        if (v && this.isLightModel) this.GetAllStructureRegions().forEach(region => region.visible = false);
        // New format: Collection.setVisibilityForAll → Region.sectionsVisibility also showed every section.surfaceGroup
        // (per-element meshes); MODEL draws the merged lightSection instead. No-op on old-format and light-model assets.
        if (v) this.reapplyNewFormatSectionVisuals('MODEL');
        if (this.lightCampaign) this.lightCampaign.setVisibilityForAll(v);
    }

    /**
     * New format only: re-applies the mode's section sub-group visuals (surfaceGroup,
     * linearGroup, lightSectionGroup, borderGroup) on the visible structure regions after a
     * visibility map was applied. Asset.setRegionsVisibility writes section.surfaceGroup.visible
     * along with section.group.visible, so without this every per-element mesh is drawn over
     * the merged lightSection in MODEL/REGIONS.
     *
     * Never touches region/section visibility (region.group, section.group): the visibility map
     * keeps the final say over which sections are shown. Mirrors renderNewFormat /
     * applyRegionModeVisuals:
     * - MODEL, no light model: setViewOnModelMode per visible structure region.
     * - MODEL, light model: nothing (the structure regions stay hidden).
     * - REGIONS: setViewOnRegionMode per visible structural region; non-structural regions
     *   keep their old-format-like surface rendering.
     * - SECTIONS: setViewOnSectionMode per visible section.
     * Old-format assets: no-op.
     */
    public reapplyNewFormatSectionVisuals(mode: Modes): void {
        if (!this.isNewModelMode) return;

        const regions = this.GetStructureVisibleRegions() || [];
        switch (mode) {
            case 'MODEL':
                if (this.isLightModel) return;
                regions.forEach(region => region.setViewOnModelMode());
                break;
            case 'REGIONS':
                regions.forEach(region => {
                    if (region.isStructural) region.setViewOnRegionMode();
                });
                break;
            case 'SECTIONS':
                regions.forEach(region => {
                    region.sections?.forEach(section => {
                        if (section.visible) section.setViewOnSectionMode();
                    });
                });
                break;
        }
    }

    public setVisibilityForLightModel(v: boolean): void {
        this.mode = 'MODEL';
        const assetStateRoot = new AssetState();
        assetStateRoot.isRoot = true;
        // this.assetStateList.addAssetState(assetStateRoot);
        this.lightCampaign.setVisibilityForAll(v);
    }

    public resetToDefault() {
        this.changeSectionVisibility = true;
        this.mode = 'MODEL';
        this.changeSectionVisibility = false;
        this.setVisibilityForAll(true);
        this.GetAllStructureRegions().forEach(region => {
            if (this.isNewModelMode) {
                region.setViewOnModelMode();
            } else {
                region.renderLinearElements(false);
                region.clearBorderofElements();
            }
        });
        this.InspectionCampaigns.forEach(inspectionCampaign => {
            // inspectionCampaign.setElementsProperties(regionId, elementsProperties, this.materials);
            inspectionCampaign.setVisibilityForAll(false);
        });

        this.RepairCampaigns.forEach(repairCampaign => {
            // inspectionCampaign.setElementsProperties(regionId, elementsProperties, this.materials);
            repairCampaign.setVisibilityForAll(false);
        });

        this.SensorCampaign?.setVisibilityForAll(true);

        this.lightCampaign?.setVisibilityForAll(true);
    }

    public get VisibleRegionsCounter(): number {
        return this.StructureCampaigns.map(x => x.VisibleRegions.length).reduce((a, b) => a + b);
    }

    public setElementsProperties(regionId: string, elementsProperties: any): void {
        if (this.StructureCampaigns) {
            this.StructureCampaigns.forEach(structureCampaign => {
                structureCampaign.setElementsProperties(regionId, elementsProperties, this.materials);
            });
        }
    }

    public setElementsRepairProperties(regionId: string, elementsProperties: any): void {
        this.RepairCampaigns.forEach(repairCampaign => {
            repairCampaign.setElementsProperties(regionId, elementsProperties, this.materials);
        });
    }

    public changeDocumentsVisibility() {
        this.documentsVisibility = this.DocumentCollection.isVisible;
        if (!this.documentsVisibility) this.DocumentCollection.showDocuments(this.GetVisibleRegions(), this.mode);
        else this.DocumentCollection.hideDocuments();
    }

    public changeDocumentsVisibilityMode() {
        // Check if DocumentCollection is defined
        if (!this.DocumentCollection) {
            return;
        }

        // Check if DocumentCollection has isVisible property
        if (this.DocumentCollection.isVisible) {
            this.DocumentCollection.hideDocuments();
            this.DocumentCollection.showDocuments(this.GetVisibleRegions(), this.mode);
        }
    }

    public addInspectionCollection(inspectionCollection: InspectionCampaign): void {
        this.Campaigns.push(inspectionCollection);
        this.group.add(inspectionCollection.group);
        inspectionCollection.assetId = this.assetInfo.AssetId;
        // if (Util.isNullOrUndefined(inspectionCollection.CollectionInfoModel.RegionId) && inspectionCollection.CollectionInfoModel.RegionIds)
        //     inspectionCollection.CollectionInfoModel.RegionId = inspectionCollection.CollectionInfoModel.RegionIds[0]
    }

    public addRepairCollection(repairCollection: RepairCampaign): void {
        this.Campaigns.push(repairCollection);
        this.group.add(repairCollection.group);
        repairCollection.assetId = this.assetInfo.AssetId;
        if (Util.isNullOrUndefined(repairCollection.CollectionInfoModel.RegionId) && repairCollection.CollectionInfoModel.RegionIds)
            repairCollection.CollectionInfoModel.RegionId = repairCollection.CollectionInfoModel.RegionIds[0]
    }

    public addProtectionElementsCollection(protectionCollection: ProtectionElementsCampaign): void {
        if (this.Campaigns) {
            this.Campaigns.push(protectionCollection);
        }
        this.group.add(protectionCollection.group);
        protectionCollection.assetId = this.assetInfo.AssetId;
    }

    public addWeightTemporalElementsCollection(weightTemporalCollection: WeightTemporalElementsCampaign): void {
        if (this.TemporalCampaigns) {
            this.TemporalCampaigns.push(weightTemporalCollection);
        }
        this.group.add(weightTemporalCollection.group);
        weightTemporalCollection.assetId = this.assetInfo.AssetId;
    }

    public addCriticalAreaCollection(CriticalAreaCollection: CriticalAreaCampaign): void {
        this.Campaigns.push(CriticalAreaCollection);
        this.group.add(CriticalAreaCollection.group);
        CriticalAreaCollection.assetId = this.assetInfo.AssetId;
        if (Util.isNullOrUndefined(CriticalAreaCollection.CollectionInfoModel.RegionId) && CriticalAreaCollection.CollectionInfoModel.RegionIds)
            CriticalAreaCollection.CollectionInfoModel.RegionId = CriticalAreaCollection.CollectionInfoModel.RegionIds[0]
    }

    public addCollection(collection: Collection): void {
        this.Campaigns.push(collection);
        this.group.add(collection.group);
        if (collection.Type === "SensorCampaign") {
            this.cssGroup.add((collection as SensorCollection).cssGroup);
        }

        collection.assetId = this.assetInfo.AssetId;
    }

    public addStructuralConnectionCollection(collection: StructuralConnectionCollection): void {
      if (this._StructuralConnectionCampaign) {
        this.removeStructuralConnectionCollection();
      }
      this.Campaigns.push(collection);
      this.group.add(collection.group); // Adds the THREE.Group to the main Scene
      this._StructuralConnectionCampaign = collection;
    }

    public removeStructuralConnectionCollection(): void {
      this.Campaigns = this.Campaigns.filter(x => x.Type !== 'StructuralConnectionCampaign');
      this.group.remove(this._StructuralConnectionCampaign.group);
      this._StructuralConnectionCampaign = null;
    }

    public returnModelTemporalElement(id:string):NonWorkableElement{
        let temporalElement = null;
        for (const temporalCampaigns of this.TemporalCampaigns) {
            temporalElement = temporalCampaigns.modelTemporalElements.find(x => x.Guid === id);
        }
        return temporalElement;
    }

    public clearModelTemporalElement():void{
        for (const temporalCampaigns of this.TemporalCampaigns) {
            if(temporalCampaigns instanceof WeightTemporalElementsCampaign){
                (temporalCampaigns as WeightTemporalElementsCampaign).clearWeightMeasurementToolMode();
            }
        }
    }
}
